import { defineComponent as _defineComponent } from 'vue'
import UserLogin from '@/app/components/session/UserLogin.vue';
import { BrandingImageType } from 'ah-api-gateways';
import { useAuthStore } from '@/app/store/authStore';
import { useTheme } from 'ah-theme';
import { useRouter } from 'vue-router/composables';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  props: {
  redirectTo: { type: String, default: '' },
  redirectToQuery: { type: String, default: '' },
},
  setup(__props) {

const props = __props;



const authStore = useAuthStore();

const theme = useTheme();

const router = useRouter();

const userLogin = ref<UserLogin>();

const currentStage = ref<String>('');

const splashLogoLink = computed(() => {
  let out = theme.val?.logos.find((l) => l.type === BrandingImageType.SPLASH_IMAGE)?.link;
  return out;
});

function resendCode() {
  userLogin.value?.refreshOtpCode();
}

function onLoginSuccess() {
  if (authStore.isUnverifiedSelfRegister) {
    router.push('/register');
    return;
  }
  let path = authStore.isClientUser ? '/dashboard' : '/admin';
  let query = {};
  try {
    query = JSON.parse(props.redirectToQuery);
  } catch (e) {}
  if (props.redirectTo) {
    path = props.redirectTo;
  }
  router.push({ path, query });
}

/**
 * Clearing session for the use case where a logged in user goes back
 * to the login screen while with a registration session
 */
if (authStore.hasRegistrationSession) {
  authStore.logout();
}

return { __sfc: true,props, authStore, theme, router, userLogin, currentStage, splashLogoLink, resendCode, onLoginSuccess, UserLogin }
}

})